
import { createReducer } from '../utils/misc';
import {
    DRAWER
} from '../constants/index';

const initialState = {
    openMenu: false
};

export default createReducer(initialState, {
    [DRAWER]: (state, payload) =>
        Object.assign({}, state, {
            openMenu: payload.openMenu,
        }),
    })


// WEBPACK FOOTER //
// ./src/reducers/drawer.js